import Vue from "vue";
import VueRouter from "vue-router";
import { leavePublicShell } from "@/lib/session";

Vue.use(VueRouter);

import Login from "../views/Login.vue";

const routes = [
  { path: "/login", name: "Login", component: Login, props: true },
  { path: "/login/:domain", component: Login, props: true },
  { path: "/app/login", redirect: "/login" },
  { path: "/app/login/:domain", redirect: (to) => `/login/${to.params.domain}` },
  {
    path: "/loginauto/:domain?",
    name: "LoginAuto",
    component: () => import(/* webpackChunkName: "loginauto" */ "../views/LoginAuto.vue"),
    props: true,
  },
  { path: "/app/loginauto/:domain?", redirect: (to) => (to.params.domain ? `/loginauto/${to.params.domain}` : "/loginauto") },
  { path: "/LoginAuto/:domain?", redirect: (to) => (to.params.domain ? `/loginauto/${to.params.domain}` : "/loginauto") },
  {
    path: "/",
    beforeEnter() {
      leavePublicShell();
    },
  },
  {
    path: "*",
    beforeEnter() {
      leavePublicShell();
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
